import client from './axiosInstance';
import {
  IAddingHolidayData,
  IFetchHolidaysParams,
} from 'features/holidaysList/holidaysListTypes';

export const fetchHolidaysList = async (
  params: IFetchHolidaysParams | void
) => {
  if (params) {
    const { searchValue, skip, take } = params;
    const searchStringQuery =
      searchValue && searchValue.length > 0 ? `search=${searchValue}` : '';
    const skipQuery = `${
      searchValue && searchValue.length > 0 ? '&' : ''
    }skip=${skip}`;
    const takeQuery = `&take=${take}`;
    const queryStr = `?${searchStringQuery}${skipQuery}${takeQuery}`;
    return await client.get(`/time-off/holidays${queryStr}`);
  } else {
    return await client.get(`/time-off/holidays`);
  }
};

export const addNewHoliday = async (data: IAddingHolidayData) => {
  return await client.post(`/time-off/holidays`, {
    ...data,
  });
};

export const deleteHoliday = async (holidayId: number) => {
  return await client.delete(`/time-off/holidays/${holidayId}`);
};
